module.exports = __webpack_public_path__ + "static/media/financial-report.655c1d46.svg";